import React, { useEffect, useRef, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import $ from "jquery";
import "jquery-ui/dist/jquery-ui.js";
import "jquery-ui/themes/base/all.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import config from "../../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaFilePdf } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";

function ChallanStatusCont({ challanNo, setChallanNo }) {
  const navigate = useNavigate();
  // const dateInputRef = useRef(null);
  const modalRef = useRef(null);
  const iframeRef = useRef(null);
  const tableRef = useRef(null);
  const tableRef2 = useRef(null);
  const fileInputRef = useRef(null);
  const [challanData, setChallanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedExamFees, setSelectedExamFees] = useState("");
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const token = localStorage.getItem("token");
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const movetodashboard = (e) => {
    e.preventDefault();
    navigate("/dashboard");
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const centCode = localStorage.getItem("CentCode");
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
      }
      if (!centCode || !token) {
        console.error("Missing cent_code or token");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${config.API_BASE_URL}/Auth/GetListChallanStatus`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ cenT_CODE: centCode }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        if (!data.data.challan_data || data.data.challan_data.length === 0) {
          Swal.fire({
            icon: "info",
            title: "No Data Available",
            text: "No challan records found.",
          });
          setChallanData([]); // Ensure it's empty
        } else {
          setChallanData(data.data.challan_data);
          // console.log(data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "warning",
          title: "Data not found.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  useEffect(() => {
    if (challanData.length > 0) {
      const table = $(tableRef.current).DataTable();

      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        table.destroy();
      }

      $(tableRef.current).DataTable({
        paging: false,
        info: false,
      });
    }
  }, [challanData]);

  useEffect(() => {
    if (modalData.length > 0) {
      const table = $(tableRef2.current).DataTable();

      if ($.fn.DataTable.isDataTable(tableRef2.current)) {
        table.destroy();
      }

      $(tableRef2.current).DataTable({
        paging: false,
        info: false,
      });
    }
  }, [modalData]);
  // 
  const [formData, setFormData] = useState({
    challanNo: "", // Added challan number
    utrNumber: "",
    paymentDate: "",
    bankName: "",
    amount: "",
    document: null,
  });

  const openModal = (challanNo, examFees) => {
    setSelectedExamFees(examFees);
    setSelectedChallanNo(challanNo);
    setFormData((prevFormData) => ({
      ...prevFormData,
      challanNo: challanNo,
      amount: examFees,
    }));
    $('#uploadModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
  };
  const openModal2 = (challanNo) => {
    localStorage.setItem("modalOpen", "true");
    $('#pdfModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
    const pdfUrl = `/generate-pdf/${challanNo}`;
    console.log(pdfUrl);
    if (iframeRef.current) {
      iframeRef.current.src = pdfUrl;
    }

  };
  const openModal3 = async (challanNo) => {
    try {
      setLoading(true);
      const response = await axios.post(`${config.API_BASE_URL}/auth/GetStudentListByChallan`, {
        challaN_NO: challanNo
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalData(response.data.data.student_list);
      localStorage.setItem("modalOpen", "true");
      setShowModal(true); // Show modal
      $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
    } catch (error) {
      console.error("Error fetching modal data:", error);
    } finally {
      setLoading(false);
    }
  };
  const closeModal = () => {
    // Clear the form data
    setFormData({
      challanNo: "",
      utrNumber: "",
      paymentDate: "",
      bankName: "",
      document: null,
    });

    // Clear the file input field
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset file input
    }

    // Close the modal
    $("#uploadModal").removeClass("show").css("display", "none");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  };
  const closeModal2 = () => {
    localStorage.removeItem("modalOpen");
    $("#pdfModal").removeClass("show").css("display", "none");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  };
  const closeModal3 = () => {
    setModalData([]); // Reset the modal data
    setShowModal(false); // Hide the modal
    localStorage.removeItem("modalOpen"); // Optionally
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  };
  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];

      if (!file) return; // Do nothing if no file is selected

      // Allowed file types
      const allowedTypes = ["image/jpeg", "image/jpg", "application/pdf"];
      const maxSize = 1024 * 1024; // 1MB in bytes

      // Validate file type (only JPG and PDF)
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Invalid File",
          text: "Only JPG and PDF files are allowed.",
        });
        fileInputRef.current.value = ""; // Clear the file input
        return;
      }

      // Validate file size (max 1MB)
      if (file.size > maxSize) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "File size should not exceed 1MB.",
        });
        fileInputRef.current.value = ""; // Clear the file input
        return;
      }

      // Update state if conditions are met
      setFormData({
        ...formData,
        [name]: file,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };



  const handleSubmit = async () => {
    if (
      !formData.challanNo ||
      !formData.utrNumber ||
      !formData.paymentDate ||
      !formData.bankName ||
      !formData.document
    ) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "All fields are mandatory. Please fill out all required details.",
        customClass: {
          popup: "custom-swal",
        },
      });
      return;
    }

    try {
      setLoading(true);

      const file = formData.document;
      let base64File = null;

      // File Validation (Type & Size)
      const allowedTypes = ["image/jpeg", "image/jpg", "application/pdf"];
      const maxSize = 1024 * 1024; // 1MB

      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Invalid File Type",
          text: "Only JPG and PDF files are allowed.",
          customClass: { popup: "custom-swal" },
        });
        setLoading(false);
        return;
      }

      if (file.size > maxSize) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "File size must be 1MB or smaller.",
          customClass: { popup: "custom-swal" },
        });
        setLoading(false);
        return;
      }

      // Convert file to Base64 (only for images)
      if (file) {
        base64File = await toBase64(file);

        if (file.type === "image/jpeg" || file.type === "image/jpg") {
          base64File = base64File.replace(/^data:image\/\w+;base64,/, "");
        } else if (file.type === "application/pdf") {
          base64File = base64File.replace(/^data:application\/pdf;base64,/, "");
        }
      }


      const formatDate = (dateString) => {
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
      };

      const submissionData = {
        challaN_NO: formData.challanNo,
        transactioN_NUMBER: formData.utrNumber,
        paymenT_DATE: formatDate(formData.paymentDate),
        banK_NAME: formData.bankName,
        cH_FILE: file.name,
        image_Base64String: base64File,
      };
      console.log(submissionData);
      const token = localStorage.getItem("token");
      const response = await fetch(`${config.API_BASE_URL}/auth/PaymentInformationSave`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(submissionData),
      });

      if (!response.ok) {
        throw new Error("Failed to submit payment details");
      }

      console.log(response);
      setLoading(false);
      closeModal();
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Payment details submitted successfully!",
        customClass: { popup: "custom-swal" },
      }).then(() => {
        window.location.reload();
      });

    }
    catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Error submitting form. Please try again.",
        customClass: { popup: "custom-swal" },
      });
      setLoading(false);
    }
  };


  // Helper function to convert file to Base64
  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const generateExcel = async () => {
    // Check if modalData is empty
    if (!modalData.length) {
      Swal.fire("No Data", "No student data available for export.", "warning");
      return;
    }

    // Check if token is missing
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Authentication Error", "Token is missing. Please log in.", "error");
      return;
    }

    try {
      // Start loading
      setLoading(true);
      const now = new Date();
      const formattedDateTime = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

      // Calculate total exam fees
      const totalFees = modalData.reduce((total, student) => total + (parseFloat(student.FEES_AMOUNT) || 0), 0);

      // Prepare Excel worksheet
      const ws = XLSX.utils.aoa_to_sheet([
        ["Annexure"],
        ["Centre Code:", localStorage.getItem("CentCode")],
        ["Centre Name:", localStorage.getItem("schoolName")],
        ["Challan No:", modalData[0]?.CHALLAN_NO],
        ["Generation Date & Time:", formattedDateTime],
        [],
        [],
        ["Roll No", "Name of Candidate", "Gender", "Father's Name", "Mother's Name", "Caste", "Exam Type", "Exam Fees"]
      ]);

      // Prepare rows from modalData
      const rows = modalData.map(student => [
        student.ROLL_NO || "",
        student.CAND_NAME || "",
        student.SEX || "",
        student.FATHERS_NAME || "",
        student.MOTHERS_NAME || "",
        student.CATEGORY || "",
        student.EXAM_TYPE || "",
        student.FEES_AMOUNT || "",
      ]);

      // Add rows to the worksheet
      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      // Add total fees row
      XLSX.utils.sheet_add_aoa(ws, [["", "", "", "", "", "", "Total Fees:", totalFees]], { origin: -1 });

      // Merge cells for title row
      ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

      // Adjust column widths
      ws["!cols"] = [
        { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 15 },
        { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 30 }
      ];

      // Create Excel workbook and append the sheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Checklist");

      // Write Excel file and download
      const fileName = `Annexure_${modalData[0]?.CHALLAN_NO}.xlsx`;
      XLSX.writeFile(wb, fileName);

      // Stop loading
      setLoading(false);

      // Show success message
      Swal.fire({
        title: "Success",
        text: "Excel file has been generated successfully!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false
      });

    } catch (error) {
      console.error("Error generating Excel:", error);

      // Stop loading on error
      setLoading(false);

      Swal.fire("Error", "An error occurred while generating the checklist.", "error");
    }
  };


  return (
    <div className="pc-container">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12 breadcrumb">
                <div className="page-header-title">
                  <h5 className="m-b-10">CHALLAN STATUS</h5>
                </div>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><a href="" onClick={movetodashboard}>Home</a></li>
                  <li className="breadcrumb-item"><a href="">Challan Status</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ padding: '0px' }}>
          <div className="col-md-12">
            <div class="card tbl-card" style={{ border: '1px solid #1890ff' }}>

              <div class="card-body padding-10">
                <div class="table-responsive">
                  <table ref={tableRef} class="table table-hover table-bordered mb-0">
                    <thead>
                      <tr className='table-info'>
                        <th className="text-start">Sl No.</th>
                        <th>Challan No.</th>
                        <th>Challan Generation Date & Time</th>
                        <th className="text-start">No. of Students</th>
                        <th className="text-start">Download Annexure</th>
                        <th>Payment Status</th>
                        <th>Payment Details</th>
                        <th>Board Approval Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {challanData.length > 0 ? (
                        challanData.map((challan, index) => (
                          <tr key={index}>
                            <td className="text-start">{index + 1}</td>
                            <td>
                              <span>{challan.CHALLAN_NO}</span><br />
                              <span><b>Exam Fees: Rs.</b> {challan.EXAM_FEES}</span>
                            </td>
                            <td>{challan.CHALLAN_DATE_TIME}</td>
                            <td><b>{challan.NO_OF_STUDENT}</b></td>
                            <td><button className="btn btn-sm btn-info" onClick={() => openModal3(challan.CHALLAN_NO)}><i className="fa fa-print"></i>&nbsp;Print Annexure</button></td>
                            <td>
                              {challan.PAYMENT_STATUS === "COMPLETE" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>Completed</span>
                              ) : (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>Pending</span>
                              )}
                            </td>
                            <td>
                              {challan.PAYMENT_STATUS === "COMPLETE" ? (
                                <>
                                  <span><b>Payment Status:</b> {challan.PAYMENT_STATUS === "COMPLETE" ? "COMPLETED" : challan.PAYMENT_STATUS}</span><br />
                                  <span><b>Payment Mode:</b> {challan.PAYMENT_MODE || "N/A"}</span><br />
                                  <span><b>Transaction Date:</b> {challan.TRANSACTION_DATE_TIME || "N/A"}</span>
                                </>
                              ) : (
                                <a
                                  className="btn btn-success btn-sm text-white"
                                  onClick={() => openModal(challan.CHALLAN_NO, challan.EXAM_FEES)}
                                >
                                  <i className="fa fa-upload"></i>&nbsp;Upload Details
                                </a>
                              )}
                            </td>
                            <td>
                              {challan.ADMIN_STATUS === "APPROVED" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>
                                  Approved
                                </span>
                              ) : challan.ADMIN_STATUS === "PENDING" ? (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>
                                  Pending
                                </span>
                              ) : (
                                <div>
                                  <span className="badge bg-light-danger border border-danger" style={{ fontSize: '12px' }}>
                                    Rejected
                                  </span>
                                  <p><b>Remarks:</b> {challan.ADMIN_REMARKS}</p>
                                </div>
                              )}
                            </td>

                            <td>
                              <a
                                className="btn btn-warning btn-sm text-white"
                                onClick={() => openModal2(challan.CHALLAN_NO)}
                                style={{ cursor: "pointer" }}
                              >
                                <i className="fa fa-print"></i>&nbsp;Re-Print Challan
                              </a>

                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center text-danger">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>


                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="modal fade" id="uploadModal" tabIndex="-1" role="dialog" ref={modalRef}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Upload Payment Details</h5>
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>
            <div className="modal-body">
              <table className="table">
                <tbody>
                  <tr>
                    <td style={{ width: '40%' }}>UTR / General No.<span className="text-danger">*</span> :</td>
                    <td>
                      <input
                        type="text"
                        name="utrNumber"
                        className="form-control form-control-sm"
                        value={formData.utrNumber}
                        onChange={handleInputChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Payment Date<span className="text-danger">*</span> :</td>
                    <td>
                      <input
                        className="form-control form-control-sm"
                        type="date"
                        name="paymentDate"
                        value={formData.paymentDate}
                        onChange={handleInputChange}
                        max={new Date().toISOString().split("T")[0]}
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Bank Name<span className="text-danger">*</span> :</td>
                    <td>
                      <input
                        type="text"
                        name="bankName"
                        className="form-control form-control-sm"
                        value={formData.bankName}
                        onChange={handleInputChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Amount :</td>
                    <td>
                      <input
                        type="text"
                        name="amount"
                        className="form-control form-control-sm text-right"
                        disabled
                        value={`Rs. ${selectedExamFees}`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Upload document<span className="text-danger">*</span> :</td>
                    <td>
                      <b>( Max Size : 1MB, Format : JPG & PDF )</b>
                      <input
                        type="file"
                        name="document"
                        accept=".jpg,.jpeg,.pdf"
                        className="form-control form-control-sm"
                        onChange={handleInputChange}
                        ref={fileInputRef} // Add ref to file input
                      />

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={closeModal}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                <i className="fa fa-save"></i>&nbsp;Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="pdfModal" role="dialog" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Challan PDF Preview</h5>
              <button type="button" className="btn-close" onClick={closeModal2}></button>
            </div>
            <div className="modal-body">
              <iframe ref={iframeRef} width="100%" height="500px" style={{ border: "none" }}></iframe>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal2}>Close</button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header bg-info">
                <h5 className="modal-title">Challan No : {modalData[0]?.CHALLAN_NO}<br />Generation Date & Time : {modalData[0]?.CHALLAN_DATE_TIME}</h5>
                <button type="button" className="btn-close" onClick={closeModal3}></button>
              </div>
              <div className="modal-body">
                {modalData.length > 0 && (
                  <div className="col-md-3" style={{ position: 'absolute', top: '35px', zIndex: '1', left: '20px' }}>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={generateExcel}
                    >
                      <RiFileExcel2Fill style={{ marginTop: "-4px" }} />&nbsp;Export to Excel
                    </button>
                  </div>
                )}
                <table ref={tableRef2} class="table table-hover table-bordered mb-0">
                  <thead>
                    <tr className='table-info'>
                      <th className="text-start">Sl No.</th>
                      <th>Roll No</th>
                      <th>Name of Candidate</th>
                      <th className="text-start">Gender</th>
                      <th className="text-start">Father's Name</th>
                      <th className="text-start">Mother's Name</th>
                      <th>Caste</th>
                      <th>Exam Type</th>
                      <th>Exam Fees</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalData.map((student, index) => (
                      <tr key={index}>
                        <td className="text-start">{index + 1}</td>
                        <td>{student.ROLL_NO}</td>
                        <td>{student.CAND_NAME}</td>
                        <td>{student.SEX}</td>
                        <td className="text-start">{student.FATHERS_NAME}</td>
                        <td className="text-start">{student.MOTHERS_NAME}</td>
                        <td className="text-start">{student.CATEGORY}</td>
                        <td>{student.EXAM_TYPE}</td>
                        <td>{student.FEES_AMOUNT}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="table-warning">
                      <td colSpan="8" className="text-end fw-bold">Total Fees:</td>
                      <td className="fw-bold">
                        {modalData.reduce((total, student) => total + (parseFloat(student.FEES_AMOUNT) || 0), 0)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal3}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>

  )
}

export default ChallanStatusCont